import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import page components
import ShiftPlanning from '../pages/shiftPlanning';
import ShiftPlanLayout from '../components/ShiftPlanLayout';
import InboundTrailerVolume from '../pages/inboundTrailerVolume';
import Settings from '../pages/settings';
import StationAssignment from '../pages/stationAssignment';
import Dashboard from '../pages/flowPlanning/dashboard';
import FlowMapGated from '../pages/flowPlanning/flowMap/FlowMapGated';
import BuffersGated from '../pages/flowPlanning/buffers/BuffersGated';
import WorkItems from '../pages/workItems';
import WorkItemDetail from '../pages/workItemDetail';
import StationAssignmentLayout from '../components/StationAssignmentLayout';
import AssociateViewPage from '../pages/stationAssignment/associateView';
import StationAssignmentHistory from '../pages/stationAssignment/history';
import PublishedAssignmentContainer from '../pages/stationAssignment/published';
import LeaderboardPage from '../pages/leaderboard';
import ImageQualityGated from '../pages/imageQuality/ImageQualityGated';
import AssociateScorecardsGated from '../pages/associateScorecards/AssociateScorecardsGated';
import NavigationGuard from '../components/NavigationGuard';
import { ROUTES } from '../utils/constants';
import { useResolveStationCode } from '../hooks/useResolveStationCode';

const GeneralRouter: React.FC = () => {
    // Fallback stationCode resolution — reads ?stationCode= from the URL
    // and seeds shiftPlanSlice in Redux if not already set at store init.
    useResolveStationCode();

    return (
        <NavigationGuard>
            <div className="main-content-wrapper">
                <Routes>
                    {/* Default route */}
                    <Route path="/" element={<ShiftPlanning />} />

                    {/* Shift planning process routes - nested under ShiftPlanLayout */}
                    <Route path="/shift-plan/*" element={<ShiftPlanLayout />} />

                    {/* Legacy route for backward compatibility */}
                    <Route path="/inbound" element={<InboundTrailerVolume />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path={ROUTES.WORK_ITEMS} element={<WorkItems />} />
                    <Route path={ROUTES.WORK_ITEM_DETAIL} element={<WorkItemDetail />} />

                    {/* Shift rotation routes */}
                    <Route path="/shift-rotation" element={<StationAssignment />} />
                    <Route path={ROUTES.SHIFT_ROTATION_ASSOCIATE_VIEW} element={<AssociateViewPage />} />
                    <Route path={ROUTES.SHIFT_ROTATION_HISTORY} element={<StationAssignmentHistory />} />
                    <Route path={ROUTES.SHIFT_ROTATION_PUBLISHED} element={<PublishedAssignmentContainer />} />
                    <Route path="/shift-rotation/*" element={<StationAssignmentLayout />} />
                    <Route path="/reporting" element={<Dashboard />} />
                    {/* Visual Flow Map — Andon cards + Volume Flow map over the same per-path data. */}
                    <Route path={ROUTES.FLOW_MAP} element={<FlowMapGated />} />
                    {/* Buffers — summary, a card per buffer, and the container drill-down. */}
                    <Route path={ROUTES.BUFFERS} element={<BuffersGated />} />
                    <Route path={ROUTES.LEADERBOARD} element={<LeaderboardPage />} />
                    <Route path={ROUTES.IMAGE_QUALITY} element={<ImageQualityGated />} />
                    <Route path={ROUTES.ASSOCIATE_SCORECARDS} element={<AssociateScorecardsGated />} />
                </Routes>
            </div>
        </NavigationGuard>
    );
};

export default GeneralRouter;
